import { render, staticRenderFns } from "./MaintenanceItemPackageFormDialog.vue?vue&type=template&id=2110cc09"
import script from "./MaintenanceItemPackageFormDialog.vue?vue&type=script&lang=ts"
export * from "./MaintenanceItemPackageFormDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports